module.exports = __webpack_public_path__ + "img/workout-notebook_B095GJW42Q.66a91ea2.jpg";